import type { CourseModule } from "@/core/types";
import { lektionZellformatvorlagen } from "./lektion-01-zellformatvorlagen";
import { lektionLayout } from "./lektion-02-layout";

export const modulFormatvorlagen: CourseModule = {
  id: "formatvorlagen",
  title: "Zellformatvorlagen und Layout",
  summary:
    "Benannte Formate statt Handarbeit – und die Layoutentscheidungen, die eine " +
    "Tabelle lesbar machen, ohne ihr die Beweglichkeit zu nehmen.",
  level: "Grundlagen",
  lessons: [lektionZellformatvorlagen, lektionLayout],
};
